import { render, staticRenderFns } from "./qrcCode.vue?vue&type=template&id=47a94f94&scoped=true"
import script from "./qrcCode.vue?vue&type=script&lang=js"
export * from "./qrcCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a94f94",
  null
  
)

export default component.exports